import React from 'react'
import style from './articles.style'

const RetailCrm = ({ classes }) => {
  return (
    <article className={classes.article}>
      <h2>Подключение Comagic</h2>
      
      <ol>
        <li>
          Перейдите в меню "Уведомления" и добавьте новое уведомление
          <figure className={classes.helpArticleFigure}>
            <img src="/images/comagichelp1.png" alt="true" />
            <figcaption>Создание уведомления</figcaption>
          </figure>
        </li>
        <li>
          Заполните поля как на примере
          <ol>
            <li>Выберите способ уведомления HTTP</li>
            <li>Метод POST</li>
            <li>URL: https://romi.center/api/comagic</li>
            <li>
              В поле "Тело" вставьте код, который вы получили на этапе подключения в Дата Споттере 
              <figure className={classes.helpArticleFigure}>
                <img src="/images/comagichelp2.png" alt="true" />
                <figcaption>Создание уведомления</figcaption>
              </figure>
            </li>
          </ol>
        </li>
      </ol>
    </article>
  )
}

export default style(RetailCrm)
